import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { APP_HOME_PATH } from "../config/routes";

const RequireRole = ({ children, allowedRoles, orPermissions }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (!isAuthenticated && !isLoading) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return null;
  }

  const roles = user?.roles || [];
  if (allowedRoles?.length) {
    const roleOk = allowedRoles.some((r) => roles.includes(r));
    const permOk =
      Array.isArray(orPermissions) &&
      orPermissions.some((p) => user?.permissions?.includes(p));
    if (!roleOk && !permOk) {
      return <Navigate to={APP_HOME_PATH} replace />;
    }
    return children;
  }

  const hasAccess = user?.permissions?.includes("manage_users");
  if (!hasAccess) {
    return <Navigate to={APP_HOME_PATH} replace />;
  }

  return children;
};

export default RequireRole;
